<ul>
  
    <label class="form-field-group-label" data-behaviour="toggleable" data-toggle-class="form-field-group-label-toggled" data-target=".crm_data_fields">CRM data fields</label>
    <div class="crm_data_fields drag-container" >
      
      <li class="form-field-template-item" data-behaviour="form-field-template" data-type="Text Field" template="first_name">
        <div class="form-field-template-icon">
          <div class="icon form-text-input"></div>
        </div>
        <div class="form-field-template-content">
          <h5>First Name</h5>
          <span>Text Field</span>
        </div>
      </li>
    
      <li class="form-field-template-item" data-behaviour="form-field-template" data-type="Text Field" template="last_name">
        <div class="form-field-template-icon">
          <div class="icon form-text-input"></div>
        </div>
        <div class="form-field-template-content">
          <h5>Last Name</h5>
          <span>Text Field</span>
        </div>
      </li>
    
      <li class="form-field-template-item" data-behaviour="form-field-template" data-type="Select" template="sex">
        <div class="form-field-template-icon">
          <div class="icon patients"></div>
        </div>
        <div class="form-field-template-content">
          <h5>Assigned Sex at Birth</h5>
          <span>Select</span>
        </div>
      </li>
    
      <li class="form-field-template-item" data-behaviour="form-field-template" data-type="Text Field" template="ssn">
        <div class="form-field-template-icon">
          <div class="icon form-text-input"></div>
        </div>
        <div class="form-field-template-content">
          <h5>Social Security Number</h5>
          <span>Text Field</span>
        </div>
      </li>
    
      <li class="form-field-template-item" data-behaviour="form-field-template" data-type="Text Field" template="medicare_id_number">
        <div class="form-field-template-icon">
          <div class="icon form-text-input"></div>
        </div>
        <div class="form-field-template-content">
          <h5>Medicare ID Number</h5>
          <span>Text Field</span>
        </div>
      </li>
    
      <li class="form-field-template-item" data-behaviour="form-field-template" data-type="Text Field" template="external_ehr_id">
        <div class="form-field-template-icon">
          <div class="icon form-text-input"></div>
        </div>
        <div class="form-field-template-content">
          <h5>EHR ID</h5>
          <span>Text Field</span>
        </div>
      </li>
    
      <li class="form-field-template-item" data-behaviour="form-field-template" data-type="Telephone" template="phone_number">
        <div class="form-field-template-icon">
          <div class="icon phone"></div>
        </div>
        <div class="form-field-template-content">
          <h5>Phone Number</h5>
          <span>Telephone</span>
        </div>
      </li>
    
      <li class="form-field-template-item" data-behaviour="form-field-template" data-type="Email" template="email_address">
        <div class="form-field-template-icon">
          <div class="icon email"></div>
        </div>
        <div class="form-field-template-content">
          <h5>Email Address</h5>
          <span>Email</span>
        </div>
      </li>
    
      <li class="form-field-template-item" data-behaviour="form-field-template" data-type="Number" template="zip_code">
        <div class="form-field-template-icon">
          <div class="icon form-number"></div>
        </div>
        <div class="form-field-template-content">
          <h5>Zip Code</h5>
          <span>Number</span>
        </div>
      </li>
    
      <li class="form-field-template-item" data-behaviour="form-field-template" data-type="Date Picker" template="birthday">
        <div class="form-field-template-icon">
          <div class="icon event"></div>
        </div>
        <div class="form-field-template-content">
          <h5>Date of Birth</h5>
          <span>Date Picker</span>
        </div>
      </li>
    
      <li class="form-field-template-item" data-behaviour="form-field-template" data-type="Select" template="callback">
        <div class="form-field-template-icon">
          <div class="icon form-select"></div>
        </div>
        <div class="form-field-template-content">
          <h5>Best Time to Call</h5>
          <span>Select</span>
        </div>
      </li>
    
      <li class="form-field-template-item" data-behaviour="form-field-template" data-type="Radio Buttons" template="opt_in">
        <div class="form-field-template-icon">
          <div class="icon form-radio-buttons"></div>
        </div>
        <div class="form-field-template-content">
          <h5>Opt-In Fields</h5>
          <span>Radio Buttons</span>
        </div>
      </li>
    
      <li class="form-field-template-item" data-behaviour="form-field-template" data-type="Textarea" template="message_allowed">
        <div class="form-field-template-icon">
          <div class="icon form-textarea"></div>
        </div>
        <div class="form-field-template-content">
          <h5>Message Allowed Fields</h5>
          <span>Textarea</span>
        </div>
      </li>
    
      <li class="form-field-template-item" data-behaviour="form-field-template" data-type="Text Field" template="address">
        <div class="form-field-template-icon">
          <div class="icon event"></div>
        </div>
        <div class="form-field-template-content">
          <h5>Address</h5>
          <span>Text Field</span>
        </div>
      </li>
    
      <li class="form-field-template-item" data-behaviour="form-field-template" data-type="Smart Input" template="organizational_unit">
        <div class="form-field-template-icon">
          <div class="icon form-select"></div>
        </div>
        <div class="form-field-template-content">
          <h5>Office Location</h5>
          <span>Smart Input</span>
        </div>
      </li>
    
    </div>
  
    <label class="form-field-group-label" data-behaviour="toggleable" data-toggle-class="form-field-group-label-toggled" data-target=".special_fields">Special fields</label>
    <div class="special_fields drag-container" >
      
      <li class="form-field-template-item" data-behaviour="form-field-template" data-type="Radio Buttons" template="eligibility_check">
        <div class="form-field-template-icon">
          <div class="icon form-radio-buttons"></div>
        </div>
        <div class="form-field-template-content">
          <h5>Eligibility Check</h5>
          <span>Radio Buttons</span>
        </div>
      </li>
    
      <li class="form-field-template-item" data-behaviour="form-field-template" data-type="Telephone" template="additional_phone">
        <div class="form-field-template-icon">
          <div class="icon phone"></div>
        </div>
        <div class="form-field-template-content">
          <h5>Additional Phone Number</h5>
          <span>Telephone</span>
        </div>
      </li>
    
      <li class="form-field-template-item" data-behaviour="form-field-template" data-type="Smart Input" template="location_selector">
        <div class="form-field-template-icon">
          <div class="icon form-select"></div>
        </div>
        <div class="form-field-template-content">
          <h5>Location Selector</h5>
          <span>Smart Input</span>
        </div>
      </li>
    
      <li class="form-field-template-item" data-behaviour="form-field-template" data-type="Email" template="additional_email">
        <div class="form-field-template-icon">
          <div class="icon email"></div>
        </div>
        <div class="form-field-template-content">
          <h5>Additional Email Address</h5>
          <span>Email</span>
        </div>
      </li>
    
      <li class="form-field-template-item" data-behaviour="form-field-template" data-type="Date Picker" template="additional_date">
        <div class="form-field-template-icon">
          <div class="icon event"></div>
        </div>
        <div class="form-field-template-content">
          <h5>Additional Date</h5>
          <span>Date Picker</span>
        </div>
      </li>
    
      <li class="form-field-template-item" data-behaviour="form-field-template" data-type="Date Picker" template="additional_datetime">
        <div class="form-field-template-icon">
          <div class="icon form-text-input"></div>
        </div>
        <div class="form-field-template-content">
          <h5>Additional Date Time</h5>
          <span>Date Picker</span>
        </div>
      </li>
    
      <li class="form-field-template-item" data-behaviour="form-field-template" data-type="Email" template="email_sign_up">
        <div class="form-field-template-icon">
          <div class="icon form-text-input"></div>
        </div>
        <div class="form-field-template-content">
          <h5>Email Signup Fields</h5>
          <span>Email</span>
        </div>
      </li>
    
      <li class="form-field-template-item" data-behaviour="form-field-template" data-type="" template="list_sign_up">
        <div class="form-field-template-icon">
          <div class="icon form-text-input"></div>
        </div>
        <div class="form-field-template-content">
          <h5>List Sign-up</h5>
          <span></span>
        </div>
      </li>
    
      <li class="form-field-template-item" data-behaviour="form-field-template" data-type="Smart Input" template="sessions">
        <div class="form-field-template-icon">
          <div class="icon sessions"></div>
        </div>
        <div class="form-field-template-content">
          <h5>Sessions</h5>
          <span>Smart Input</span>
        </div>
      </li>
    
    </div>
  
    <label class="form-field-group-label" data-behaviour="toggleable" data-toggle-class="form-field-group-label-toggled" data-target=".generic_fields">Generic fields</label>
    <div class="generic_fields drag-container" >
      
      <li class="form-field-template-item" data-behaviour="form-field-template" data-type="Text Field" template="text">
        <div class="form-field-template-icon">
          <div class="icon form-text-input"></div>
        </div>
        <div class="form-field-template-content">
          <h5>Text Field</h5>
          <span>Text Field</span>
        </div>
      </li>
    
      <li class="form-field-template-item" data-behaviour="form-field-template" data-type="Textarea" template="textarea">
        <div class="form-field-template-icon">
          <div class="icon form-textarea"></div>
        </div>
        <div class="form-field-template-content">
          <h5>Text Area</h5>
          <span>Textarea</span>
        </div>
      </li>
    
      <li class="form-field-template-item" data-behaviour="form-field-template" data-type="Select" template="select">
        <div class="form-field-template-icon">
          <div class="icon form-select"></div>
        </div>
        <div class="form-field-template-content">
          <h5>Drop down</h5>
          <span>Select</span>
        </div>
      </li>
    
      <li class="form-field-template-item" data-behaviour="form-field-template" data-type="Radio Buttons" template="radio">
        <div class="form-field-template-icon">
          <div class="icon form-radio-buttons"></div>
        </div>
        <div class="form-field-template-content">
          <h5>Radio buttons</h5>
          <span>Radio Buttons</span>
        </div>
      </li>
    
      <li class="form-field-template-item" data-behaviour="form-field-template" data-type="Radio Buttons" template="revealed_content_radio">
        <div class="form-field-template-icon">
          <div class="icon form-radio-buttons"></div>
        </div>
        <div class="form-field-template-content">
          <h5>Revealing Radio Buttons</h5>
          <span>Radio Buttons</span>
        </div>
      </li>
    
      <li class="form-field-template-item" data-behaviour="form-field-template" data-type="Checkbox" template="checkbox">
        <div class="form-field-template-icon">
          <div class="icon form-checkbox"></div>
        </div>
        <div class="form-field-template-content">
          <h5>Checkbox</h5>
          <span>Checkbox</span>
        </div>
      </li>
    
      <li class="form-field-template-item" data-behaviour="form-field-template" data-type="Hidden" template="hidden">
        <div class="form-field-template-icon">
          <div class="icon form-text-input"></div>
        </div>
        <div class="form-field-template-content">
          <h5>Hidden Field</h5>
          <span>Hidden</span>
        </div>
      </li>
    
    </div>
  
    <label class="form-field-group-label" data-behaviour="toggleable" data-toggle-class="form-field-group-label-toggled" data-target=".formatting">Formatting</label>
    <div class="formatting drag-container" >
      
      <li class="form-field-template-item" data-behaviour="form-field-template" data-type="Text" template="h2">
        <div class="form-field-template-icon">
          <div class="icon headline"></div>
        </div>
        <div class="form-field-template-content">
          <h5>Title</h5>
          <span>Text</span>
        </div>
      </li>
    
      <li class="form-field-template-item" data-behaviour="form-field-template" data-type="Text" template="h3">
        <div class="form-field-template-icon">
          <div class="icon headline"></div>
        </div>
        <div class="form-field-template-content">
          <h5>Subtitle</h5>
          <span>Text</span>
        </div>
      </li>
    
      <li class="form-field-template-item" data-behaviour="form-field-template" data-type="Text" template="h4">
        <div class="form-field-template-icon">
          <div class="icon headline"></div>
        </div>
        <div class="form-field-template-content">
          <h5>Heading</h5>
          <span>Text</span>
        </div>
      </li>
    
      <li class="form-field-template-item" data-behaviour="form-field-template" data-type="HTML" template="html">
        <div class="form-field-template-icon">
          <div class="icon form-textarea"></div>
        </div>
        <div class="form-field-template-content">
          <h5>HTML Content</h5>
          <span>HTML</span>
        </div>
      </li>
    
      <li class="form-field-template-item" data-behaviour="form-field-template" data-type="Formatting" template="group_break">
        <div class="form-field-template-icon">
          <div class="icon split"></div>
        </div>
        <div class="form-field-template-content">
          <h5>Group Break</h5>
          <span>Formatting</span>
        </div>
      </li>
    
      <li class="form-field-template-item" data-behaviour="form-field-template" data-type="Formatting" template="line_break">
        <div class="form-field-template-icon">
          <div class="icon split"></div>
        </div>
        <div class="form-field-template-content">
          <h5>Line Break</h5>
          <span>Formatting</span>
        </div>
      </li>
    
    </div>
  
</ul>
